const t=t=>!new URL(t,"http://fake.tld").protocol.startsWith("javascript"),r=r=>{if(!t(r))throw new Error(`Unsafe path used: '${r}'`)};export{r as assertSafePath,t as isSafePath};
//# sourceMappingURL=is-safe-path.js.map
